import { Form, FormContext, Input, Flex } from 'dash-ui';
import { ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const StreetInput = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <Flex flex={1} flexDirection="column" mr={2}>
      <Form.Label required>{t('forms:labels.streetName')}</Form.Label>
      <Input
        value={formState.street || ''}
        w="100%"
        placeholder={t('forms:placeholders.nameOfStreet') || ''}
        onChange={onChange(FormFields.Street)}
        $errorType={formErrors[FormFields.Street]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Street]?.type}>
        {formErrors[FormFields.Street]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default StreetInput;
